import {
    METAMODEL_LOAD,
    METAMODEL_RELOAD,
    METAMODEL_RECEIVE
} from '../constants';
import {
    LoadAction,
    ReloadAction,
    ReceiveAction
} from '~/frontend/src/actions/metamodel';
import metaModel from '~/shared/src/utilities/metaModel';


export type MetaModelState = Partial<{
    isLoading : boolean;
    isReady : boolean;
    timestamp : number;
}>;


const relevantActions = [
    METAMODEL_LOAD,
    METAMODEL_RELOAD,
    METAMODEL_RECEIVE
];


export default function metamodelReducer( state : MetaModelState = {}, action : LoadAction | ReloadAction | ReceiveAction ) : MetaModelState {
    let retVal = state;

    if ( relevantActions.includes( action.type ) ) {
        retVal = {
            ...state
        };

        switch ( action.type ) {
            case METAMODEL_LOAD:
                retVal.isLoading = true;
                break;

            case METAMODEL_RELOAD:
                retVal.isReady = false;
                retVal.isLoading = true;
                break;

            case METAMODEL_RECEIVE:
                retVal.isReady = true;
                retVal.isLoading = false;
                retVal.timestamp = Object.values( metaModel ).reduce( ( innerRetVal, mM ) => {
                    return Math.max( innerRetVal, mM.getTimestamp() );
                }, 0 );
                break;
        }
    }

    return retVal;
}
